<template>
  <div v-if="item && item.round_rooms!==0"> 
    <v-card
      v-for="(temp,i) in item.round_rooms" 
      :key="i"
      outlined
      class="mt-1"
    >  
      <v-row no-gutters> 
        <v-col cols="4">
          <div class="ml-5 d-flex justify-start">  
            <div>
              <v-img 
                width="20"
                :src="imagePath(temp.game_id, item.name)"
              />
            </div>
          </div> 
        </v-col> 
        <v-col cols="4">
          <div class="d-flex justify-center">
            {{ temp.name }}
          </div>
        </v-col>
      </v-row>
      <v-divider />
      <v-row
        no-gutters
        cols="12"
      >
        <v-col md="6">
          <v-row no-gutters>
            <v-col
              cols="11"
              class="d-flex justify-center"
            >
              {{ $t('lotto-type.three-up') }} 
            </v-col>
            <v-col
              cols="11"
              class="d-flex justify-center"
            >
              <h4  
                v-if="temp.win_number&&temp.win_number.three_up"
              >
                {{ temp.win_number.three_up }}
              </h4>
              <h4 v-else>
                {{ item.round_status.name }}
              </h4> 
            </v-col> 
          </v-row>  
        </v-col>
        <v-col
          md="6"
          class="d-flex justify-center"
        >
          <v-row no-gutters>
            <v-col
              cols="11"
              class="d-flex justify-center"
            >
              {{ $t('lotto-type.two-down') }} 
            </v-col>
            <v-col
              cols="11"
              class="d-flex justify-center"
            >
              <h4 
                v-if="temp.win_number&&temp.win_number.two_down"
              >
                {{ temp.win_number.two_down }}
              </h4>
              <h4 v-else>
                {{ item.round_status.name }}
              </h4> 
            </v-col>
          </v-row>  
        </v-col>
      </v-row> 
    </v-card>  
  </div>
</template>
<script>
import { imagePath } from '@/plugins/mapImage'
export default {
    props : {
        item : {
            type:Object,
            default : ()=> {}
        }
    },  
    methods : {
        imagePath 
    }
}
</script>